(function () {
  'use strict';

  if (window.subscriptionsNewDomInitialized) return;
  window.subscriptionsNewDomInitialized = true;

  const DEFAULT_SUBSCRIPTION_DISCOUNT = 20;
  let initTimer = null;
  const RECEIVE_ICON = `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 24L32 16L48 24L32 32L16 24Z"/><path d="M16 24V44L32 52V32"/><path d="M48 24V44L32 52"/><path d="M24 20L40 28"/></g><circle cx="46" cy="44" r="8" fill="white"/><path d="M42 44L45 47L50 40" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  const CANCEL_ICON = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="16" stroke="currentColor" stroke-width="2"/><path d="M18 18L30 30" stroke="currentColor" stroke-width="2"/><path d="M30 18L18 30" stroke="currentColor" stroke-width="2"/></svg>`;
  const INFO_ICON = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="16" stroke="currentColor" stroke-width="2"/><path d="M24 20V30" stroke="currentColor" stroke-width="2"/><circle cx="24" cy="16" r="1.5" fill="currentColor"/></svg>`;

  const selectors = {
    appContainer: '.shopify_subscriptions_app_container',
    planCard: '.plan_card',
    subscriptionGroup: '.subscription_group',
    sellingPlanInput: 'input[data-radio-type="selling_plan"]',
    oneTimeInput: 'input[data-radio-type="one_time_purchase"]',
    customUnitRadio: '.custom-one-time-radio',
    quantityInput: '.quantity__input',
    discountLabel: '.subscription-discount-label-new-dom',
    priceSummary: '.subscription-price-summary',
    subscribeItems: '.subscribe-items'
  };

  function parsePriceValue(value) {
    if (!value || typeof value !== 'string') return null;

    const normalized = value
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\.(?=\d{3}(?:[.,]|$))/g, '')
      .replace(',', '.');

    const number = Number.parseFloat(normalized);
    return Number.isFinite(number) ? number : null;
  }

  function getAppContainer(element) {
    return element && element.closest ? element.closest(selectors.appContainer) : null;
  }

  function getPlanCard(appContainer) {
    return appContainer ? appContainer.querySelector(selectors.planCard) : null;
  }

  function getOneTimeInput(appContainer) {
    return appContainer ? appContainer.querySelector(selectors.oneTimeInput) : null;
  }

  function getSellingPlanGroup(planCard) {
    if (!planCard) return null;
    const sellingInput = planCard.querySelector(selectors.sellingPlanInput);
    return sellingInput ? sellingInput.closest(selectors.subscriptionGroup) : null;
  }

  function getScopedAppContainer() {
    return document.querySelector(selectors.appContainer);
  }

  function getDurationText() {
    const productoData = document.querySelector('#producto-data');
    return productoData?.dataset?.duracion || '35';
  }

  function getDiscountPercent(planCard) {
    if (!planCard) return DEFAULT_SUBSCRIPTION_DISCOUNT;

    const sellingPlanInput = planCard.querySelector(selectors.sellingPlanInput);
    const oneTimeInput = planCard.querySelector(selectors.oneTimeInput);

    const originalPrice =
      parsePriceValue(sellingPlanInput?.dataset.variantCompareAtPrice) ||
      parsePriceValue(oneTimeInput?.dataset.variantPrice) ||
      parsePriceValue(planCard.querySelector('.subscription_group--hidden-one-time .in_widget_price')?.textContent);

    const subscriptionPrice =
      parsePriceValue(sellingPlanInput?.dataset.variantPrice) ||
      parsePriceValue(sellingPlanInput?.closest('label')?.querySelector('.in_widget_price')?.textContent);

    if (originalPrice && subscriptionPrice && originalPrice > subscriptionPrice) {
      return Math.round(((originalPrice - subscriptionPrice) / originalPrice) * 100);
    }

    return DEFAULT_SUBSCRIPTION_DISCOUNT;
  }

  function getPriceTexts(planCard) {
    if (!planCard) return { original: '', current: '' };

    const sellingPlanInput = planCard.querySelector(selectors.sellingPlanInput);
    const oneTimeInput = planCard.querySelector(selectors.oneTimeInput);

    const original =
      oneTimeInput?.dataset.variantPrice?.trim() ||
      planCard.querySelector('.subscription_group--hidden-one-time .in_widget_price')?.textContent?.trim() ||
      '';

    const current =
      sellingPlanInput?.dataset.variantPrice?.trim() ||
      sellingPlanInput?.closest('label')?.querySelector('.in_widget_price')?.textContent?.trim() ||
      '';

    return { original, current };
  }

  function ensureDiscountLabel(planCard) {
    if (!planCard) return null;

    let label = planCard.querySelector(selectors.discountLabel);
    if (!label) {
      label = document.createElement('span');
      label.className = 'subscription-discount-label-new-dom';
      planCard.appendChild(label);
    }

    label.textContent = `-${getDiscountPercent(planCard)}%`;
    return label;
  }

  function ensurePriceSummary(planCard) {
    if (!planCard) return null;

    const sellingPlanGroup = getSellingPlanGroup(planCard);
    const headerWrapper = sellingPlanGroup ? sellingPlanGroup.querySelector(':scope > .title_and_price_wrapper') : null;
    if (!headerWrapper) return null;

    let summary = headerWrapper.querySelector(selectors.priceSummary);
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'subscription-price-summary';
      headerWrapper.appendChild(summary);
    }

    const prices = getPriceTexts(planCard);
    const compareMarkup =
      prices.original && prices.current && prices.original.replace(/\s/g, '') !== prices.current.replace(/\s/g, '')
        ? `<s class="compare-at-price">${prices.original}</s>`
        : '';

    summary.innerHTML = `${compareMarkup}<span class="final-price">${prices.current || prices.original || ''}</span>`;
    return summary;
  }

  function ensureSubscribeItems(planCard) {
    if (!planCard) return null;

    const sellingPlanGroup = getSellingPlanGroup(planCard);
    const groupName = sellingPlanGroup ? sellingPlanGroup.querySelector('.group_name') : null;
    if (!groupName) return null;

    let container = groupName.querySelector(selectors.subscribeItems);
    if (!container) {
      container = document.createElement('div');
      container.className = 'subscribe-items';
      groupName.appendChild(container);
    }

    const duration = getDurationText();
    container.innerHTML = `
      <span class="subscribe-item item-receive">${RECEIVE_ICON}<span>Rec&iacute;belo cada ${duration} d&iacute;as.</span></span>
      <span class="subscribe-item item-cancel">${CANCEL_ICON}<span>Cancela cuando quieras.</span></span>
      <span class="subscribe-item item-info">${INFO_ICON}<a href="/pages/plan-de-suscripcion">M&aacute;s informaci&oacute;n.</a></span>
    `;
    return container;
  }

  function updateSelectedState(appContainer) {
    const planCard = getPlanCard(appContainer);
    if (!planCard) return;

    const sellingPlanGroup = getSellingPlanGroup(planCard);
    const isSellingPlanSelected = !!planCard.querySelector(`${selectors.sellingPlanInput}:checked`);
    const discountLabel = ensureDiscountLabel(planCard);
    ensurePriceSummary(planCard);
    ensureSubscribeItems(planCard);

    planCard.classList.toggle('is-selected', isSellingPlanSelected);
    planCard.classList.toggle('is-unselected', !isSellingPlanSelected);
    if (discountLabel) {
      discountLabel.classList.toggle('active', isSellingPlanSelected);
    }

    if (sellingPlanGroup) {
      sellingPlanGroup.classList.toggle('is-selected', isSellingPlanSelected);
      sellingPlanGroup.classList.toggle('is-unselected', !isSellingPlanSelected);
    }
  }

  function clickOneTimeOption(appContainer) {
    const oneTimeInput = getOneTimeInput(appContainer);
    if (!oneTimeInput) return;

    if (!oneTimeInput.checked) {
      oneTimeInput.click();
    } else {
      oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateSelectedState(appContainer);
  }

  function syncQuantities(value) {
    if (!value) return;

    document.querySelectorAll(selectors.quantityInput).forEach((input) => {
      if (String(input.value) !== String(value)) {
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function initPlanCard(appContainer) {
    const planCard = getPlanCard(appContainer);
    if (!planCard) return;

    planCard.classList.add('subscriptions-new-dom-ready');
    ensureDiscountLabel(planCard);
    ensurePriceSummary(planCard);
    ensureSubscribeItems(planCard);

    const oneTimeInput = getOneTimeInput(appContainer);
    const sellingPlanGroup = getSellingPlanGroup(planCard);

    if (oneTimeInput) {
      const oneTimeGroup = oneTimeInput.closest(selectors.subscriptionGroup);
      if (oneTimeGroup) {
        oneTimeGroup.classList.add('subscription_group--hidden-one-time');
      }
    }

    if (sellingPlanGroup) {
      sellingPlanGroup.classList.add('subscription_group--selling-plan');
    }

    updateSelectedState(appContainer);
  }

  function initAllPlanCards() {
    document.querySelectorAll(selectors.appContainer).forEach(initPlanCard);
  }

  function scheduleInit(delay) {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(() => {
      initAllPlanCards();
    }, delay || 0);
  }

  function handleSubscriptionChange(target) {
    const appContainer = getAppContainer(target);
    if (!appContainer) return;

    updateSelectedState(appContainer);
  }

  function handleCustomUnitChange(target) {
    const appContainer = getScopedAppContainer();
    if (!appContainer) return;

    clickOneTimeOption(appContainer);
    syncQuantities(target.value || 1);
  }

  function bindEvents() {
    document.addEventListener('change', (event) => {
      const { target } = event;
      if (!(target instanceof Element)) return;

      if (target.matches(selectors.sellingPlanInput) || target.matches(selectors.oneTimeInput)) {
        handleSubscriptionChange(target);
        scheduleInit(50);
      }

      if (target.matches(selectors.customUnitRadio)) {
        handleCustomUnitChange(target);
        scheduleInit(50);
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const sellingPlanGroup = target.closest('.subscription_group--selling-plan');
      if (
        sellingPlanGroup &&
        !target.closest('a') &&
        !target.matches(selectors.sellingPlanInput)
      ) {
        const appContainer = getAppContainer(sellingPlanGroup);
        const sellingPlanInput = appContainer ? getPlanCard(appContainer)?.querySelector(selectors.sellingPlanInput) : null;
        if (sellingPlanInput && !sellingPlanInput.checked) {
          sellingPlanInput.click();
          return;
        }
      }

      const radioLabel = target.closest(`${selectors.planCard} .group_list_item.custom_radio_button`);
      if (!radioLabel) return;

      const appContainer = getAppContainer(radioLabel);
      if (!appContainer) return;

      window.setTimeout(() => updateSelectedState(appContainer), 0);
    });

    document.addEventListener('variant:changed', () => {
      scheduleInit(150);
    });

    if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
        scheduleInit(150);
      });
    }
  }

  function init() {
    initAllPlanCards();
    window.setTimeout(initAllPlanCards, 300);
    window.setTimeout(initAllPlanCards, 1000);
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
